import React from 'react'
import { Marker, InfoWindow } from '@react-google-maps/api'
import MarkerIcon from 'images/icons/marker.png'

const LocationMapMarker = ({
  location,
  isSelected = false,
  changeSelectedLocation,
  children,
  isHovered = false,
}) => {
  const handleMarkerClick = () => {
    if (isSelected === false) {
      changeSelectedLocation(location)
    }
  }

  const handleInfoWindowClosed = () => {
    changeSelectedLocation(null)
  }

  return (
    <>
      <span>
        <Marker
          title={isHovered ? ` ` : ``}
          icon={MarkerIcon}
          onClick={handleMarkerClick}
          position={location.coordinates}
        />
        {isSelected === true && (
          <InfoWindow
            onCloseClick={handleInfoWindowClosed}
            className={`map--infowindow`}
            position={location.coordinates}
          >
            {children}
          </InfoWindow>
        )}
      </span>
    </>
  )
}
export default LocationMapMarker
